import { render, staticRenderFns } from "./pictureGalleryOverview.vue?vue&type=template&id=42bfd996&scoped=true"
import script from "./pictureGalleryOverview.vue?vue&type=script&lang=js"
export * from "./pictureGalleryOverview.vue?vue&type=script&lang=js"
import style0 from "./pictureGalleryOverview.vue?vue&type=style&index=0&id=42bfd996&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bfd996",
  null
  
)

export default component.exports